module.exports = __webpack_public_path__ + "static/media/22.9876ab51.jpg";